import { useState, useEffect } from 'react'
import styled from 'styled-components'

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`

const Modal = styled.div`
  width: min(420px, 90vw);
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 28px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
`

const Heading = styled.h2`
  margin: 0;
  font-size: 22px;
  color: #0e1f4a;
`

const Fieldset = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #21313c;
  text-transform: uppercase;
`

const Input = styled.input`
  border: 1px solid #d0d7de;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 14px;
  outline: none;

  :focus {
    border-color: #4c3de3;
    box-shadow: 0 0 0 2px rgba(76, 61, 227, 0.15);
  }
`

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
`

const Button = styled.button`
  min-width: 110px;
  padding: 11px 18px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  border: ${({ $variant }) =>
    $variant === 'primary' ? 'none' : '1px solid #c4c4c4'};
  background: ${({ $variant }) =>
    $variant === 'primary' ? '#4c3de3' : '#ffffff'};
  color: ${({ $variant }) => ($variant === 'primary' ? '#ffffff' : '#4c3de3')};

  :hover {
    opacity: 0.9;
  }
`

const ErrorMessage = styled.p`
  margin: 0;
  color: #c62828;
  font-size: 13px;
  font-weight: 600;
`

const Helper = styled.p`
  margin: 0;
  color: #5b6570;
  font-size: 13px;
`

function AdminLoginModal({
  visible,
  onClose,
  onSubmit,
  errorMessage,
  loading = false,
}) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  useEffect(() => {
    if (visible) {
      setUsername('')
      setPassword('')
    }
  }, [visible])

  if (!visible) {
    return null
  }

  function handleSubmit(e) {
    e.preventDefault()
    onSubmit({ username, password })
  }

  return (
    <Backdrop>
      <Modal>
        <Heading>Admin Access</Heading>
        <Helper>Enter the admin credentials to manage trip settings.</Helper>
        <form onSubmit={handleSubmit}>
          <Fieldset>
            <Label htmlFor="admin-username">Username</Label>
            <Input
              id="admin-username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              autoComplete="off"
              placeholder="admin"
              disabled={loading}
            />
          </Fieldset>
          <Fieldset>
            <Label htmlFor="admin-password">Password</Label>
            <Input
              id="admin-password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="••••••••"
              disabled={loading}
            />
          </Fieldset>
          {errorMessage ? <ErrorMessage>{errorMessage}</ErrorMessage> : null}
          <ButtonRow>
            <Button type="button" onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button $variant="primary" type="submit" disabled={loading}>
              {loading ? 'Checking…' : 'Log In'}
            </Button>
          </ButtonRow>
        </form>
      </Modal>
    </Backdrop>
  )
}

export default AdminLoginModal
